import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function ValuePropSection() {
  const benefits = [
    {
      title: 'Instant credit decisions',
      description:
        'Get access to the funds you need in minutes, not days, with no impact on your personal credit.',
    },
    {
      title: 'Flexible repayments',
      description:
        'Choose payment terms that fit your cash flow, from 30 days up to 12 months.',
    },
    {
      title: 'No hidden fees',
      description:
        'Transparent pricing with no surprises or prepayment penalties.',
    },
    {
      title: 'Boost your business credit',
      description:
        "Build your company's credit history with every on-time payment.",
    },
  ];

  return (
    <div className="flex flex-col gap-6 mx-6 md:mx-2">
      {benefits.map((benefit, index) => (
        <div className="flex items-start gap-3" key={index}>
          <FontAwesomeIcon
            icon={['fal', 'check']}
            className="text-green-500 !mx-0 text-xl"
          />
          <div>
            <h4 className="font-semibold text-primary">{benefit.title}</h4>
            <p className="text-sm text-secondary-gray">{benefit.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
